import React, { useEffect, useMemo } from "react";
import { IItemProps } from "devextreme-react/form";

import { PageProps, UpdateDomTitleForForm } from "@ezhou/core";
import { MainCard } from "@ezhou/app_mantis_1_1";

import { UserType, userTypeOptions } from "../../model/constants/enums";

import { InactivatableCrudDataGrid } from "../common/InactivatableCrudDataGrid";

import { dummyUserRow } from "./model/metaData";

const Users = (pageProps: PageProps) => {
  const logger = pageProps.loggerProvider.getLogger("UsersPage");

  useEffect(() => {
    UpdateDomTitleForForm(pageProps);
  });

  const editorItemOptions = useMemo(() => new Map<string, IItemProps>([
    [
      "userType",
      {
        editorType: "dxSelectBox",
        editorOptions: {
          dataSource: userTypeOptions,
          searchEnabled: true,
          placeholder: "Select a user type",
        },
      },
    ],
  ]), []);

  return (
    <MainCard>
      <InactivatableCrudDataGrid
        pageProps={pageProps}
        logger={logger}
        dummyRow={dummyUserRow}
        baseUrl="users"
        keyExpr="userId"
        formTitle="User"
        formColCount={2}
        formColSpan={2}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
        editorItemOptions={editorItemOptions}
      ></InactivatableCrudDataGrid>
    </MainCard>
  );
};

export default Users;
